export const LOGOUT_CTA = {
  MALE: "התנתק",
  FEMALE: "התנתקי",
};
